import React from 'react';
import { motion } from 'framer-motion';
interface InfoCardItem {
  title: string;
  description: string;
}
interface InfoCardGridProps {
  items: InfoCardItem[];
  columns?: 2 | 3 | 4;
  variant?: 'light' | 'dark';
}
const columnClasses: Record<number, string> = {
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4'
};
export function InfoCardGrid({
  items,
  columns = 3,
  variant = 'light'
}: InfoCardGridProps) {
  const isDark = variant === 'dark';
  return <div className={`grid grid-cols-1 gap-6 sm:grid-cols-2 ${columnClasses[columns]}`} data-id="element-159" data-mp="254uhgyvtyosh">
      {items.map((item, index) => <motion.div key={item.title} initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-10% 0px'
    }} transition={{
      duration: 0.4,
      delay: index * 0.06,
      ease: [0.23, 1, 0.32, 1]
    }} className={`rounded-xl border p-8 transition-colors duration-200 ${isDark ? 'border-white/10 bg-navy-light hover:border-brandgreen/50' : 'border-slate-200 bg-white hover:border-brandgreen/50'}`} data-id="element-160" data-mp="1r6cx9b54vufb" data-mpi={index}>
          <span className={`flex h-9 w-9 items-center justify-center rounded-full text-xs font-semibold ${isDark ? 'bg-brandgreen/15 text-brandgreen-light' : 'bg-navy text-white'}`} data-id="element-161" data-mp="3bx83p4m7xc30">
            {index + 1}
          </span>
          <h3 className={`mt-5 font-heading text-lg font-semibold ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-162" data-mp="2x2k3a4vod3u9">
            {item.title}
          </h3>
          <p className={`mt-3 text-sm leading-relaxed ${isDark ? 'text-slate-300' : 'text-charcoal'}`} data-id="element-163" data-mp="36zy9zcrsqe9d">
            {item.description}
          </p>
        </motion.div>)}
    </div>;
}